import {
  GET_PAYMENT_METHODS,
  GET_PAYMENT_METHODS_SUCCESS,
  GET_PAYMENT_METHODS_ERROR,

  GET_BILLING_REPORT,
  GET_BILLING_REPORT_SUCCESS,
  GET_BILLING_REPORT_ERROR,
  INITIATE_CARD_UPDATE,
  INITIATE_CARD_UPDATE_SUCCESS,
  INITIATE_CARD_UPDATE_ERROR,
  COMPLETE_CARD_UPDATE,
  COMPLETE_CARD_UPDATE_SUCCESS,
  COMPLETE_CARD_UPDATE_ERROR,
  CANCEL_CARD_UPDATE,
  CANCEL_CARD_UPDATE_SUCCESS,
  CANCEL_CARD_UPDATE_ERROR,
  COMPLETE_CARD_UPDATE_2_SUCCESS,
  COMPLETE_CARD_UPDATE_2_ERROR,
  COMPLETE_CARD_UPDATE_2,
} from './actionTypes';

export const getPaymentMethods = () => ({
  type: GET_PAYMENT_METHODS,
});

export const getPaymentMethodsSuccess = (PaymentMethod) => ({
  type: GET_PAYMENT_METHODS_SUCCESS,
  payload: PaymentMethod,
});

export const getPaymentMethodsError = (error) => ({
  type: GET_PAYMENT_METHODS_ERROR,
  payload: error,
});

export const getBillingReport = (params) => ({
  type: GET_BILLING_REPORT,
  payload: params,
});

export const getBillingReportSuccess = (billingReport) => ({
  type: GET_BILLING_REPORT_SUCCESS,
  payload: billingReport,
});

export const getBillingReportError = (error) => ({
  type: GET_BILLING_REPORT_ERROR,
  payload: error,
});

export const initiateCardUpdate = (payload) => ({
  type: INITIATE_CARD_UPDATE,
  payload,
});

export const initiateCardUpdateSuccess = (payload) => ({
  type: INITIATE_CARD_UPDATE_SUCCESS,
  payload,
});

export const initiateCardUpdateError = (error) => ({
  type: INITIATE_CARD_UPDATE_ERROR,
  payload: error,
});

export const completeCardUpdate = (payload) => ({
  type: COMPLETE_CARD_UPDATE,
  payload,
});

export const completeCardUpdateSuccess = (payload) => ({
  type: COMPLETE_CARD_UPDATE_SUCCESS,
  payload,
});

export const completeCardUpdateError = (error) => ({
  type: COMPLETE_CARD_UPDATE_ERROR,
  payload: error,
});

export const completeCardUpdate_2 = (payload) => ({
  type: COMPLETE_CARD_UPDATE_2,
  payload,
});

export const completeCardUpdate_2Success = (payload) => ({
  type: COMPLETE_CARD_UPDATE_2_SUCCESS,
  payload,
});

export const completeCardUpdate_2Error = (error) => ({
  type: COMPLETE_CARD_UPDATE_2_ERROR,
  payload: error,
});


export const cancelCardUpdate = (payload) => ({
  type: CANCEL_CARD_UPDATE,
  payload,
});

export const cancelCardUpdateSuccess = (payload) => ({
  type: CANCEL_CARD_UPDATE_SUCCESS,
  payload,
});

export const cancelCardUpdateError = (error) => ({
  type: CANCEL_CARD_UPDATE_ERROR,
  payload: error,
});
